import React from 'react'
import { useDeletePayment } from '../../../../services/payment/hooks/useDeletePayment';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useAuth } from '../../../../auth/context/AuthProvider';

type RemovePaymentProps = {
    paymentId: string
}

const RemovePayment: React.FC<RemovePaymentProps> = ({ paymentId }) => {
    const { mutate } = useDeletePayment();

    const queryClient = useQueryClient();
    const { hasRole, hasPermission } = useAuth();

    const onRemove = (id: string) => {
        if (!hasRole('dev') && !hasPermission('booking_payment')) {
            toast.error('You do not have permission to remove payment');
            return;
        }

        toast.loading('Removing payment...', { id: 'remove-payment' });

        mutate({ id: id }, {
            onSuccess: async () => {
                await queryClient.refetchQueries({
                    predicate: (query) => query.queryKey.some((key) => ['payment-list'].includes(key as string))
                });

                toast.success('Payment removed successfully', { id: 'remove-payment' });
            },
            onError: (mutationError) => {
                toast.error(mutationError?.message || 'Failed to remove payment', { id: 'remove-payment' });
            }
        });
    }

    return (
        <button
            className="btn btn-link text-danger p-0"
            onClick={() => onRemove(paymentId)}
        >
            Remove
        </button>
    )
}

export default RemovePayment